import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
} from "../../../shared/helpers/utils";

import { formatDate } from "../utils";
const ModalChart = ({
  chartData,
  color,
  isWeekly,
  stat,
}) => {
  const CustomTooltip = ({ payload, active }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const date = new Date(data.name);
      const monthName = date.toLocaleString("default", {
        month: "short",
        timeZone: "UTC",
      });
      const day = date.getDate();
      const year = date.getFullYear();
      const formattedDate = formatDate(data.name, isWeekly);
      const value = data.value;

      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          <p>{formattedDate}</p>
          <p>{`${_capitalizeText(stat.title)}: ${stat.formatter(value)}`}</p>
        </div>
      );
    }

    return null;
  };

  const formatXAxis = (tickItem) => {
    return formatDate(tickItem, isWeekly);
  };

  const formatYAxisValue = (tickItem) => {
    if (tickItem) {
      return stat.formatter(tickItem);
    } else {
      return "";
    }
  };
  return (
    <div style={{ height: 400, width: "100%", margin: "4rem -20 4rem 0" }}>
      <ResponsiveContainer>
        <AreaChart
          data={chartData}
          margin={{ top: 20, right: 0, left: 0, bottom: 60 }}
        >
          <Tooltip content={<CustomTooltip />} />
          <XAxis
            dataKey="name"
            tickFormatter={formatXAxis}
            angle={-45}
            textAnchor="end"
            dy={10}
            dx={-5}
            //  interval={2}
          />
          <YAxis dataKey="value" tickFormatter={formatYAxisValue} />
          <Area
            type="monotone"
            dataKey="value"
            stroke={`${color}`}
            fill={`${color}`}
            fillOpacity={0.2}
            strokeWidth={2}
          />
          <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ModalChart;
